/* 6 Oct 2026: also loads assets/pullorax-fuzzy.js (typo-tolerant search, wholesale page additions) on every page.
   The extra "r" parameter changes every hour, so updates to pullorax-fuzzy.js / pullorax-b2b-plus.js reach visitors within an hour. */
(function () {
  var s = document.currentScript;
  if (!s || !s.src || document.getElementById('px-fuzzy-js')) return;
  var f = document.createElement('script');
  f.id = 'px-fuzzy-js';
  var u = s.src.replace(/pullorax-back\.js/, 'pullorax-fuzzy.js');
  f.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'r=' + Math.floor(Date.now() / 3600000);
  f.defer = true;
  document.head.appendChild(f);
})();

/*
  PulloraX - BACK button (floating, top-left, every page - 30 Sept 2026).
  Came from inside the site  -> browser back (same page, same scroll position).
  Came from Google / a link  -> the logical parent page (data-fallback, set in the layout).
  Home page (data-home="1"): shown only when the visitor came from inside the site.
*/
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script) return;
  var fallback = script.dataset.fallback || '/';
  var isHome = script.dataset.home === '1';

  function internalReferrer() {
    try {
      return document.referrer && new URL(document.referrer).host === location.host && history.length > 1;
    } catch (e) { return false; }
  }
  if (isHome && !internalReferrer()) return;

  var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var labels = { he: 'חזרה', fr: 'Retour', de: 'Zurück', ja: '戻る', es: 'Volver', it: 'Indietro' };
  var label = labels[lang] || 'Back';

  var a = document.createElement('a');
  a.href = fallback;
  a.className = 'px-back';
  a.setAttribute('aria-label', label);
  a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg><span>' + label + '</span>';
  a.addEventListener('click', function (e) {
    e.preventDefault();
    if (internalReferrer()) history.back();
    else location.href = fallback;
  });
  document.body.appendChild(a);

  // Sit just under the header; rise to the top edge once the header has scrolled away.
  var sel = '#header-group, header-component, .pxmh';
  var ticking = false;
  function place() {
    ticking = false;
    var els = document.querySelectorAll(sel), bottom = 0;
    for (var i = 0; i < els.length; i++) {
      if (a.contains(els[i])) continue;
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
    }
    a.style.top = Math.max(12, Math.round(bottom + 12)) + 'px';
  }
  function queue() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
  place();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', place);
})();